import React from "react";
import moment from "moment";

const NucleoFamiliareList = ({ nucleoFamiliare }) => {
  if (!nucleoFamiliare || nucleoFamiliare.length === 0) {
    return <p className="text-muted">Nessun componente del nucleo familiare</p>;
  }

  return (
    <>
      <h6>Nucleo Familiare</h6>

      <div className="table-responsive">
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Nome</th>
              <th>CF</th>
              <th>Data nascita</th>
              <th>Relazione</th>
              <th>Reddito</th>
            </tr>
          </thead>
          <tbody>
            {nucleoFamiliare.map((c) => (
              <tr key={`${c.codiceFiscale}-${c.dataNascita}`}>
                <td>{c.nome} {c.cognome}</td>
                <td>{c.codiceFiscale}</td>
                <td>
                  {c.dataNascita
                    ? moment(c.dataNascita, "DD/MM/YYYY").format("DD/MM/YYYY")
                    : "—"}
                </td>
                <td>{c.relazioneConAssistito}</td>
                <td>{c.redditoMensile ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default NucleoFamiliareList;
